/* eslint-disable @typescript-eslint/no-non-null-assertion */
import ProblemConstruct from '../containers/problem-construct';
import React, { ReactElement } from 'react';
import { PageContent } from './page-content';
import { APP_CFG } from '../appcfg';
import {
  ProblemOption,
  PageType,
  ConstructData,
  PageDataParams
} from 'its-pages';

export interface ConstructScore {
  answeredCorrectly: number;
  answeredIncorrectly: number;
  correctAnswers: number;
  enoughAnsweredCorrectly: boolean;
  score: number;
}
export class ConstructContent extends PageContent {
  public get component(): ReactElement {
    return <ProblemConstruct constructData={this} key={this.pageData.seed} />;
  }

  public get pageType(): PageType {
    return PageType.Problem;
  }

  private logAnswers(): void {
    if (APP_CFG.log) {
      const pageData = this.pageData as ConstructData;
      const options = pageData.options;

      options.forEach((option: ProblemOption): void => {
        const text = option.isCorrectResponse + ' --> ' + option.text;
        APP_CFG.consoleLog(text);
      });
    }
  }

  public constructor(params: PageDataParams) {
    super(new ConstructData(params));
    this.logAnswers();
  }
}
